import React, { useEffect, useState, useCallback, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import PerfectScrollbar from 'react-perfect-scrollbar';
import { toast } from 'react-toastify';
import { format, parseISO } from 'date-fns';
import { FiEdit2, FiTv, FiActivity, FiX } from 'react-icons/fi';
import { FaGavel } from 'react-icons/fa';
import { Form } from '@unform/web';
import { FormHandles } from '@unform/core';
import * as Yup from 'yup';
import { useNavigate } from 'react-router-dom';

import Selecione from 'assets/selecione.svg';
import NoData from 'assets/nodata.svg';
import api from 'services/api';
import { show } from 'store/modules/dialog/actions';
import getValidationErrors from 'services/getValidationErros';
import { useModal } from 'hooks/modal';
import { ComercialItem, VetoItem } from 'pages/Eleicoes/@types';
import { Column, Container } from './PlanoMidia/styles';
import { Cargos, isEleicoesMunicipais } from 'utils/eleicoes';

import NotFound from 'components/NotFound';
import Button from 'components/Button';
import DropDownMenu from 'components/DropDownMenu';
import TextArea from 'components/TextArea';
import PlayerBaixa from 'components/PlayerBaixa';
import DatePicker from 'components/DatePicker';
import RenderIfVisible from 'components/RenderIfVisible';
import Select from 'components/Select';

interface MaterialProps {
  clienteId?: number;
}

export default function Materiais({ clienteId }: MaterialProps) {
  // react-router-dom
  const navigate = useNavigate();
  /**
   * REDUX
   * */
  const dispatch = useDispatch();
  const { callback: callbackDialog } = useSelector(
    (state: any) => state.dialog,
  );
  const { emissora } = useSelector((state: any) => state.usuario);
  /**
   * USE STATES
   */
  // const [clienteId, setClienteId] = useState(2);
  const [comerciais, setComerciais] = useState<ComercialItem[]>([]);
  const [selected, setSelected] = useState({} as ComercialItem);
  const [loadingTable, setLoadingTable] = useState(false);
  const [player, setPlayer] = useState({
    open: false,
    midia_url: '',
    pipe: false,
  });

  /**
   * Hooks
   */
  const { showModal, hideModal } = useModal();

  /**
   * USE Ref
   */
  const formVetoRef = useRef<FormHandles>(null);
  const formEditDateRef = useRef<FormHandles>(null);

  /**
   * USE CALLBACK
   */

  const handleRemoveVeto = useCallback(
    (c: ComercialItem) => {
      if (c.veto) {
        setSelected(c);
        const optionBase = {
          type: 'question',
          text: `Remover veto de ${c.titulo} ?`,
          confirmButtonText: 'CONFIRMAR',
          callback: {
            method: api.delete,
            url: `/eleicoes/veto/${c.veto.id}`,
            action: 'removeveto',
          },
          haveCallback: true,
          successMessage: 'Veto removido!',
          cancelButtonText: 'NÃO',
          showCancelButton: false,
          showConfirmButton: true,
          showCloseButton: true,
        };
        dispatch(show(optionBase));
      }
    },
    [dispatch],
  );

  const closeVideo = useCallback(() => {
    setPlayer({
      open: !player.open,
      midia_url: '',
      pipe: false,
    });
  }, [player.open]);

  const handlePlayer = useCallback(
    (comercial: ComercialItem) => {
      if (!!comercial.midia && comercial.midia.preview_url) {
        setPlayer({
          open: !player.open,
          midia_url: comercial.midia.preview_url,
          pipe: false,
        });
      } else {
        dispatch(
          show({
            type: 'warning',
            text: 'Preview indisponível no momento',
            showConfirmButton: false,
          }),
        );
      }
    },
    [dispatch, player.open],
  );

  const handleActionSelect = useCallback(
    (c: ComercialItem, action: number) => {
      switch (action) {
        case 1:
          navigate(`/historico/${c.id}`);
          break;
        case 2:
          handleRemoveVeto(c);
          break;
        case 3:
          handlePlayer(c);
          break;
        default:
          break;
      }
    },
    [handlePlayer, handleRemoveVeto],
  );

  const updateStateComerciais = useCallback((comercial: ComercialItem) => {
    setComerciais(prevState =>
      prevState.map(c => {
        return c.id === comercial.id ? comercial : c;
      }),
    );
  }, []);

  const renderObservacaoVeto = useCallback(
    (comercial: ComercialItem, edit: boolean, veto_id?: number) => {
      const handleSubmit = async (data: any) => {
        if (!formVetoRef.current) {
          return;
        }
        try {
          formVetoRef.current.setErrors({});

          const schema = Yup.object().shape({
            observacao: Yup.string().required('Preencha a observação'),
          });

          await schema.validate({ ...data }, { abortEarly: false });

          let response: { data: VetoItem };
          if (edit) {
            response = await api.put(`/eleicoes/veto/${veto_id}`, { ...data });
            toast.success(`Veto alterado`);
          } else {
            response = await api.post(`/eleicoes/veto/`, {
              ...data,
              comercial_id: comercial.id,
            });
            toast.success(`Comercial vetado`);
          }
          const newComercial = { ...comercial, veto: response.data };
          updateStateComerciais(newComercial);
          hideModal();
        } catch (error) {
          if (error instanceof Yup.ValidationError) {
            const errors = getValidationErrors(error);
            formVetoRef.current.setErrors(errors);
            return;
          }
          if (error instanceof Error) {
            toast.error(error.message);
          }
        }
      };
      return (
        <Form ref={formVetoRef} onSubmit={handleSubmit}>
          <TextArea
            placeholder="Justificativa do veto"
            name="observacao"
            height={150}
            disable={false}
            errorField=""
            icon=""
          />

          <div className="actions">
            <Button color="default" onClick={() => hideModal()}>
              CANCELAR
            </Button>
            <Button type="submit" color="primary">
              VETAR
            </Button>
          </div>
        </Form>
      );
    },
    [hideModal, updateStateComerciais],
  );

  const handleVeto = useCallback(
    (comercial: ComercialItem, edit: boolean, veto_id: number) => {
      try {
        showModal({
          title: `Vetar ${comercial.titulo}?`,

          component: renderObservacaoVeto(comercial, edit, veto_id),
        });
      } catch (error) {
        console.log(error);
      }
    },
    [renderObservacaoVeto, showModal],
  );

  const renderEditCargo = useCallback(
    (comercial: ComercialItem) => {
      const handleSubmit = async (data: { cargo: string }) => {
        if (comercial.midia)
          try {
            const response = await api.patch(
              `/comerciaists/cargo/${comercial.id}`,
              { cargo: data.cargo },
            );
            if (
              response &&
              response.data &&
              response.data.cargo === data.cargo
            ) {
              const newComercial = { ...comercial, cargo: data.cargo };
              updateStateComerciais(newComercial);
              toast.success(`Cargo alterado`);
            } else toast.error(`Falha ao alterar o cargo`);
          } catch (error) {
            toast.error(`Falha ao alterar o cargo`);
            console.log(error);
          } finally {
            hideModal();
          }
      };
      return (
        <Form ref={formEditDateRef} onSubmit={handleSubmit}>
          <Select
            name="cargo"
            menuPortalTarget={document.body}
            isSearchable={false}
            type="default"
            options={Cargos.filter(
              c => c.isEleicoesMunicipais === isEleicoesMunicipais,
            )}
            defaultValue={comercial.cargo}
            placeholder="Selecione o cargo"
            isClearable
          />

          <div className="actions">
            <Button color="default" onClick={() => hideModal()}>
              CANCELAR
            </Button>
            <Button type="submit" color="primary">
              CONFIRMAR
            </Button>
          </div>
        </Form>
      );
    },
    [hideModal, updateStateComerciais],
  );

  const handleEditCargo = useCallback(
    (comercial: ComercialItem) => {
      showModal({
        title: `Selecione o novo cargo para o material ${comercial.titulo}`,
        component: renderEditCargo(comercial),
      });
    },
    [renderEditCargo, showModal],
  );

  const renderEditDate = useCallback(
    (comercial: ComercialItem) => {
      const handleSubmit = async (data: any) => {
        if (comercial.midia) {
          try {
            const response = await api.put(`/midia/${comercial.midia.id}`, {
              ...data,
            });
            if (response && response.data) {
              const newComercial = { ...comercial, midia: response.data };
              updateStateComerciais(newComercial);
              toast.success(`Data alterada`);
            }
          } catch (error) {
            console.log(error);
          } finally {
            hideModal();
          }
        }
      };
      return (
        <Form ref={formEditDateRef} onSubmit={handleSubmit}>
          <DatePicker
            placeholderText="NOVA DATA"
            maxDate={new Date()}
            name="provided_at"
            disabled={false}
            dateFormat="dd/MM/yyyy HH:mm"
            showTimeSelect
          />

          <div className="actions">
            <Button color="default" onClick={() => hideModal()}>
              CANCELAR
            </Button>
            <Button type="submit" color="primary">
              CONFIRMAR
            </Button>
          </div>
        </Form>
      );
    },
    [hideModal, updateStateComerciais],
  );

  const handleEditDate = useCallback(
    (comercial: ComercialItem) => {
      try {
        showModal({
          title: `Selecione a data e horário de recebimento de ${comercial.titulo}`,

          component: renderEditDate(comercial),
        });
      } catch (error) {
        console.log(error);
      }
    },
    [renderEditDate, showModal],
  );

  /**
   * USE EFFECT
   */

  // verifica se callback foi realizado com sucesso para então remover item da lista
  useEffect(() => {
    if (callbackDialog && callbackDialog.success) {
      if (callbackDialog.success.action === 'removeveto') {
        setComerciais(prevState =>
          prevState.map(c => {
            return c.id === selected.id ? { ...c, veto: undefined } : c;
          }),
        );
      }
    }
  }, [callbackDialog, selected.id]);

  useEffect(() => {
    if (clienteId) {
      setLoadingTable(true);
      api
        .get('/comerciaists/eleicoes', {
          params: {
            cliente_id: clienteId,
            ...(isEleicoesMunicipais ? { emissora_id: emissora.value } : {}),
          },
        })
        .then(response => {
          setComerciais(response.data);
        })
        .catch(error => console.log(error))
        .finally(() => setLoadingTable(false));
    }
  }, [clienteId, emissora.value]);

  return (
    <Container>
      {!clienteId ? (
        <div className="freepik">
          <NotFound img={Selecione} title="Selecione">
            um partido/coligação
          </NotFound>
        </div>
      ) : !loadingTable && (!comerciais || comerciais.length <= 0) ? (
        <div className="freepik">
          <NotFound img={NoData} title="Nenhum material">
            deste partido/coligação encontrado
          </NotFound>
        </div>
      ) : (
        <PerfectScrollbar className="scroll">
          <table>
            <thead>
              <tr>
                <th style={{ width: '75px' }}>CM</th>
                <th>TITULO</th>
                <th style={{ width: '100px' }}>CARGO</th>
                <th style={{ width: '160px' }}>RECEBIDO EM</th>
                <th style={{ width: '60px' }}>VETAR</th>
                <th>VETO</th>
                <th style={{ width: '60px' }} />
              </tr>
            </thead>
            <tbody>
              {!!comerciais &&
                comerciais.map((c, index) => (
                  <RenderIfVisible defaultHeight={73} key={index} tag="tr">
                    <td>
                      <strong>{c.codmaterial}</strong>
                    </td>
                    <td>
                      <Column>
                        <strong>{c.titulo}</strong>
                        <span>{c.cliente.mnemonico}</span>
                      </Column>
                    </td>
                    <td>
                      <div className="provided_at">
                        {c.cargo ? c.cargo.toUpperCase() : '...'}
                        <Button
                          id={`editdate_${index}`}
                          fill
                          color="font"
                          round
                          onClick={() => handleEditCargo(c)}
                          disabled={!c.cargo}
                        >
                          <FiEdit2 />
                        </Button>
                      </div>
                    </td>
                    <td>
                      <div className="provided_at">
                        <strong>
                          {c.midia && c.midia.provided_at
                            ? format(
                                parseISO(c.midia.provided_at),
                                'dd/MM/yyyy HH:mm:ss',
                              )
                            : 'SEM MÍDIA'}
                        </strong>
                        <Button
                          id={`editdate_${index}`}
                          fill
                          color="font"
                          round
                          onClick={() => handleEditDate(c)}
                          disabled={!(c.midia && c.midia.provided_at)}
                        >
                          <FiEdit2 />
                        </Button>
                      </div>
                    </td>
                    <td>
                      {c.veto ? (
                        <Button
                          id={`editar_${index}`}
                          fill
                          color="font"
                          round
                          onClick={() =>
                            handleVeto(c, true, c.veto ? c.veto.id : 0)
                          }
                        >
                          <FiEdit2 />
                        </Button>
                      ) : (
                        <Button
                          id={`vetar_${index}`}
                          fill
                          color="font"
                          round
                          onClick={() => handleVeto(c, false, 0)}
                        >
                          <FaGavel />
                        </Button>
                      )}
                    </td>
                    <td>
                      <p>{c.veto?.observacao}</p>
                    </td>
                    <td>
                      <DropDownMenu
                        // isDropUp={false}
                        isDropUp={
                          index > comerciais.length - 3 && comerciais.length > 6
                        }
                        id={`acoes${index}`}
                        actions={[
                          {
                            value: 1,
                            label: 'HISTORICO',
                            icon: <FiActivity />,
                          },
                          {
                            value: 2,
                            label: 'REMOVER VETO',
                            disabled: !c.veto,
                            icon: <FiX />,
                          },
                          {
                            value: 3,
                            label: 'ASSISTIR',
                            disabled: !c.midia || !c.midia.preview_url,
                            icon: <FiTv />,
                          },
                        ]}
                        handleClick={(action: {
                          value: number;
                          label: string;
                        }) => handleActionSelect(c, action.value)}
                        disabled={false}
                      />
                    </td>
                  </RenderIfVisible>
                ))}
            </tbody>
          </table>
        </PerfectScrollbar>
      )}
      <PlayerBaixa
        open={player.open}
        toggleModal={() => closeVideo()}
        pipe={player.pipe}
        url={player.midia_url}
      />
    </Container>
  );
}
